import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import validation from "../../container/Hoc/ValidationRules";
import GlobalContext from "../../context/GlobalContext";
import {userService} from'../../services/CommonServices';
import { Auth0Provider } from '@auth0/auth0-react';
import { useAuth0 } from "@auth0/auth0-react";


const Login = (props) => {

	const[email, set_email]=useState('');
	const[password, set_password]=useState('');
    var loginData=useContext(GlobalContext)
	let navigate = useNavigate();
	const location = useLocation();

	const { loginWithRedirect, isAuthenticated } = useAuth0();

	const [accessToken, setAccessToken] = useState(null);
	const [orgId, setOrgId] = useState(null);
  	const [error, setError] = useState(null);

	useEffect(() => {
		validation();
    }, []);

	function createBasicAuthToken(email, password) {
		// Concatenate email and password
		const credentials = `${email}:${password}`;
		
		// Encode credentials in Base64
		const base64Credentials = btoa(credentials);
		
		// Create the Basic Auth token
		const authToken = `Basic ${base64Credentials}`;
		
		return authToken;
	}

	function login(event) {
		event.preventDefault();
		if (email.trim() == "") {
			alert("Email field can't be empty.");
			return false;
		}
		else if (!/^[a-z0-9._%+-]+@[a-z0-9]+\.[a-z]{2,10}(\.[a-z]{2,10})?(\.[a-z]{2,10})?(\.[a-z]{2,10})?(\.[a-z]{2,10})?$/.test(email.toLowerCase())) {
            alert("Invalid email")
            return false;
        }
		
		else if (password.trim() == "") {
			alert("Password field can't be empty.");
			return false;
		}
		else {
			var formData = {
				"email": email.toLowerCase(),
				"password": password
			}

			userService.loginApi(formData).then(response => {
				
				if (response.status === 200) {
					loginData.set_token(createBasicAuthToken(email, password))
					loginData.set_first_name(response.data.data.firstName)
					loginData.set_last_name(response.data.data.lastName)
					loginData.set_email(response.data.data.email)
					loginData.set_phone(response.data.data.phoneNumber)
					loginData.set_image(response.data.data.image)
					loginData.set_is_logged_in("true")

					sessionStorage.setItem('token', createBasicAuthToken(email, password))
					sessionStorage.setItem('first_name', response.data.data.firstName)
					sessionStorage.setItem('last_name', response.data.data.lastName)
					sessionStorage.setItem('email', response.data.data.email)
					sessionStorage.setItem('phone', response.data.data.phoneNumber)
					sessionStorage.setItem('image', response.data.data.image)
					sessionStorage.setItem('is_logged_in', "true")
					alert('logged in successfully')
					
					navigate('/dashboard')

				} else {
					alert(response);
				}
			}).catch(function (err) {
				alert(err.response.data.message)
			})
		}
	}
	


	return (
    <div class="container">
		<div class="logo_header text-center">
			<a href="#"><img src="images/logo.png" alt="" /></a>
		</div>
		<div class="login_form_outer">
			<div class="login_form">
				<h2>Sign In</h2>
				<div class="form-group">
					<label>Username or Email</label>
					<input type="text" value={email} onChange={(event) => {set_email(event.target.value);}} placeholder="" class="form-control for_username" />
				</div>
				<div class="form-group">
					<label>Password</label>
					<input type="password" value={password} onChange={(event) => {set_password(event.target.value);}} placeholder="" class="form-control" />
				</div>
				{/* <p class="forgot_password"><a href="forgot_password.html">Forgot Password?</a></p> */}
				<a href="" class="blue_btn" onClick={login}>Sign In</a>
			</div>
			<img src="images/shadow.png" alt="" class="shadow" />
		</div>
	</div>
    );
};
export default Login;